export const ADMIN_LIST_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MILLISECONDS = 300;
